import 'react-toastify/dist/ReactToastify.css';

import { FC } from 'react';
import { ToastContainer } from 'react-toastify';

export interface AuthLayoutProps {
  [x: string]: any;
}

export const AuthLayout: FC<AuthLayoutProps> = ({ children }: AuthLayoutProps) => {
  return (
    <div className="h-screen min-h-screen flex items-center justify-center">
      {children}{' '}
      <ToastContainer
        position="bottom-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
        className="toast-container"
      />
    </div>
  );
};

export default AuthLayout;
